import FeedPanel from "../components/feed/FeedPanel";
import PageHeader from "../components/PageHeader";

function Feed() {
  return (
    <div className="bg-slate-100 min-h-screen">
      <PageHeader title="Feed" subtitle="Team-wide feed · newest first" />
      <div className="max-w-[800px] mx-auto px-9 pt-7 pb-20">
        <FeedPanel />
      </div>
    </div>
  );
}

export default Feed;
